<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="encodingRules.pkId ? '编辑' : '新建'"
      width="600px"
      top="10vh"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="encodingRules"
        :rules="ruleValidate"
        class="form"
        label-width="80px">
      <el-form-item label="规则名称" prop="tableName">
        <el-input v-model="encodingRules.tableName" placeholder="请输入编码规则名称" :disabled="flag"/>
      </el-form-item>
      <el-form-item label="编码前缀">
        <el-input v-model="encodingRules.prefix" placeholder="请输入编码前缀"/>
      </el-form-item>
      <!-- <el-form-item label="规则描述">
        <el-input v-model="encodingRules.describe" placeholder="请输入规则描述"/>
      </el-form-item> -->
      <el-form-item label="编码位数">
        <el-input v-model="encodingRules.idlength" placeholder="请输入编码位数" :disabled="flag"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    name: "EncodingRulesEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        flag: false,
        encodingRules: {
          tableName: "",
          prefix: "",
          describe: "",
          idlength: "",
          pkId: "",
        },
        ruleValidate: {
          tableName: { required: true, message: "请输入规则名称" },
        },
      };
    },
    methods: {
      //开启显示
      open(row) {
        console.log(row);
        if (row) {
          this.encodingRules.tableName = row.tableName;
          this.encodingRules.pkId = row.tableName;
          this.flag = true;
          this.getData();
        }
        this.dialogVisible = true;
      },

      // 根据规则名称获取对应编码规则数据
      getData() {
        this.contentLoading = true;
        this.$http
          .get("basic", `codeRules/${this.encodingRules.tableName}`)
          .then((resp) => {
            if (resp.success) {
              this.encodingRules = Object.assign(this.encodingRules, resp.data);
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      // 提交
      handleSubmit() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "codeRules", this.encodingRules)
              .then((resp) => {
                if (resp.success) {
                  if (!this.encodingRules.pkId) {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  }
                }
                this.submitLoading = false;
                this.dialogVisible = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>
